import variables from '../variables'

import type { DividerOverrideToken } from './types'

const Divider: DividerOverrideToken = {
  colorSplit: variables.gray20
} as const

export default Divider
